import { render, staticRenderFns } from "./FranchiseeForm.vue?vue&type=template&id=5087bf56"
import script from "./FranchiseeForm.vue?vue&type=script&lang=js"
export * from "./FranchiseeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports